<p class="modal-title">Admin: Add Bot</p>
<div class="body flex flex-col">
  <form [formGroup]="botForm" (ngSubmit)="onSubmit()" #botFormRef="ngForm">
    <app-form-field
      [label]="'Name'"
      [formControl]="name"
      [errorType]="'outline'"
      [id]="'name'"
      [submitting]="isSubmitting()"
      [disabled]="isSubmitting()"
      [placeholder]="'Enter Bot Name...'"
      [error]="
        !name.valid && botFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <app-form-field
      [label]="'Password'"
      [formControl]="password"
      [errorType]="'outline'"
      [id]="'password'"
      [submitting]="isSubmitting()"
      [disabled]="isSubmitting()"
      [placeholder]="'Enter Password...'"
      [error]="
        !password.valid && botFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <app-form-field
      [label]="'SteamID'"
      [formControl]="steamid"
      [errorType]="'outline'"
      [id]="'steamid'"
      [submitting]="isSubmitting()"
      [disabled]="isSubmitting()"
      [placeholder]="'Enter SteamID...'"
      [error]="
        !steamid.valid && botFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <app-form-field
      [label]="'Shared Secret'"
      [formControl]="sharedSecret"
      [errorType]="'outline'"
      [id]="'sharedSecret'"
      [submitting]="isSubmitting()"
      [disabled]="isSubmitting()"
      [placeholder]="'Enter Shared Secret...'"
      [error]="
        !sharedSecret.valid && botFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <app-form-field
      [label]="'Identity Secret'"
      [formControl]="identitySecret"
      [errorType]="'outline'"
      [id]="'identitySecret'"
      [submitting]="isSubmitting()"
      [disabled]="isSubmitting()"
      [placeholder]="'Enter Identity Secret...'"
      [error]="
        !identitySecret.valid && botFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <app-form-field
      [label]="'API Key'"
      [formControl]="apiKey"
      [errorType]="'outline'"
      [id]="'apiKey'"
      [submitting]="isSubmitting()"
      [disabled]="isSubmitting()"
      [placeholder]="'Enter API Key...'"
      [error]="
        !apiKey.valid && botFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <app-form-field
      [label]="'Trade Link'"
      [formControl]="tradelink"
      [errorType]="'outline'"
      [id]="'tradelink'"
      [submitting]="isSubmitting()"
      [disabled]="isSubmitting()"
      [placeholder]="'Enter Trade Link...'"
      [error]="
        !tradelink.valid && botFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <button
      class="button button--style-yellow h-32 padding-x-12"
      type="submit"
      [disabled]="isSubmitting()"
    >
      Add Bot
    </button>
  </form>
</div>
